import axios from 'axios';

import { apiRoute } from '../../utils/api';
import setAuthorizationToken from '../../utils/setAuthorizationToken';
import {
	LOGIN_USER_REQUEST,
	LOGIN_USER_SUCCESS,
	LOGIN_USER_FAILURE,
	UPDATE_USER_REQUEST,
	UPDATE_USER_SUCCESS,
	UPDATE_USER_FAILURE,
	UPDATE_PASSWORD_REQUEST,
	UPDATE_PASSWORD_SUCCESS,
	UPDATE_PASSWORD_FAILURE,
	VALIDATE_USER_REQUEST,
	VALIDATE_USER_SUCCESS,
	VALIDATE_USER_FAILURE,
LOGOUT_USER,
} from '../types';

export const loginUserSuccess = user => ({
	type: LOGIN_USER_SUCCESS,
	payload: user,
})

export const validateUser = (user, token) => {
	return dispatch => {
		dispatch({
			type: VALIDATE_USER_REQUEST,
		});

		
		return axios.post(`${apiRoute}/jwt-auth/v1/token/validate`)
			.then(res => {
				localStorage.setItem('token', token);
				dispatch({
					type: VALIDATE_USER_SUCCESS,
				});
				dispatch(loginUserSuccess(user));
			})
			.catch(error => {
				dispatch({
					type: VALIDATE_USER_FAILURE,
				});
				dispatch(logoutUser());
			});
	}
}

export const loginUser = user => {
	return dispatch => {
		dispatch({
			type: LOGIN_USER_REQUEST,
		});
		
		return axios.post(`${apiRoute}/jwt-auth/v1/token`, user)
			.then(res => {
				const token = res.data.token;
				
				localStorage.setItem('token', token);
				setAuthorizationToken(token);
				dispatch(loginUserSuccess(res.data));
			})
			.catch(error => {
				let $errorMessage = 'Invalid username or password. Please try again!';
				
				if (error.response.data.code === "admin-error") {
					$errorMessage = error.response.data.message;
				}

				dispatch({
					type: LOGIN_USER_FAILURE,
					payload: $errorMessage,
				})

			});
	}
}

export const logoutUser = () => {
	localStorage.removeItem('token');
	setAuthorizationToken(false);
	return {
		type: LOGOUT_USER,
	}
}

export const updatePassword = passwords => {
	const id = 1;

	return dispatch => {
		dispatch({
			type: UPDATE_PASSWORD_REQUEST,
		});

		return axios.patch(`${apiRoute}/dale/v1/user/${id}/password`, passwords)
			.then(res => {
				dispatch({
					type: UPDATE_PASSWORD_SUCCESS,
					payload: res.data,
				});
				dispatch(logoutUser());
			})
			.catch(error => {
				dispatch({
					type: UPDATE_PASSWORD_FAILURE,
					payload: 'Something went wrong, please try again!',
				})
			});
	}
}

export const updateUser = user => {
	const id = user.id;

	return dispatch => {
		dispatch({
			type: UPDATE_USER_REQUEST,
		});

		return axios.patch(`${apiRoute}/dale/v1/user/${id}`, user)
			.then(res => {
				dispatch({
					type: UPDATE_USER_SUCCESS,
					payload: res.data,
				});
				dispatch(logoutUser());
			})
			.catch(error => {
				dispatch({
					type: UPDATE_USER_FAILURE,
					payload: 'Something went wrong, please try again!',
				})
			});
	}
}


// WEBPACK FOOTER //
// ./src/store/auth/actions.js